<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">{{$t("message.userName") }}</label>
          <div class="col-sm-3">
            <div>
              <input
                type="text"
                v-model="searchName"
                name="search"
                class="form-control input"
                maxLength="30"
              />
            </div>
          </div>
          <div class="col-sm-2">
            <div>
              <el-button type="primary" @click="search">{{$t("message.Search") }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom:60px;">
              <div class="col-sm-12" >
                <div class="pull-right">
                  <el-button
                    @click="gotoDetail"
                    v-if="checkPermission('USER_LIST_ADD')"
                  >{{$t("message.Add") }}</el-button>
                  <el-button 
                    @click="showWarning()" 
                    v-if="checkPermission('USER_LIST_DEL')"
                  >{{$t("message.Delete") }}</el-button>
                </div>
              </div>
              <div class="col-xs-12">{{total}}{{$t("message.datagridresult") }}</div>
              <el-table :data="rows"
                         
                        sort 
                        style="width: 100%" 
                        :fit="true"
                        border ref="multipleTable" 
                        @selection-change="handleSelectionChange" 
                        @sort-change="sortChange" >
                <el-table-column type="selection" width="55" ></el-table-column>
                <el-table-column prop="name" label='Username' min-width="200" ></el-table-column>
                <el-table-column prop="email" :show-overflow-tooltip="true" label='Email' min-width="220" ></el-table-column>
                <el-table-column prop="roleName" label='Role' min-width="200" ></el-table-column>
                <el-table-column prop="createdAt" v-bind:label='$t("message.createdTime")' width="170" ></el-table-column>
                <el-table-column prop="status" v-bind:label='$t("message.Status")' width="120" ></el-table-column>
                
                <el-table-column
                  label="Action"
                  width="70"
                  fixed="right"
                >
                  <template slot-scope="scope">
                     <el-button size="mini" @click="handleDbClick(scope.row)" icon="el-icon-edit" ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination 
                   layout="total, sizes, prev, pager, next, jumper" 
                   @size-change="handleSizeChange" 
                   @current-change="handleCurrentChange" 
                   :page-sizes="[10, 20, 50, 100]" 
                   :page-size="pagesize" 
                   :total="total" 
                   style="float:right;">
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0,//当前页数
      pagesize:10,//一页显示几条
      filter: "",
      searchName: "",
      searchStatus: null,
      total:0,
      rows:[],
      multipleSelection:[],
      sortType:"ASC",
      sortField:"id",
      roleId:"",
      roleList:[]
    };
  },
  created: function() {
  },
  methods: {
    async init() {
      let objdata = this.getAuthObj();
      objdata.page = {
        pageIndex: this.page,
        pageCount: this.pagesize,
      }
      objdata.type = this.roleId;
      objdata.name = this.searchName;
      objdata.apiUrl = this.apiConfig.getSystemUserList
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      let list = null;
      for (list of data.data.result.users) {
        list.createdAt = this.dateFormat(list.createdAt)
        if (list.status == 1) {
          list.status = "Active";
        } else {
          list.status = "Inactive";
        }
      }
      this.rows = data.data.result.users;
      this.total = data.data.result.total;
    },
    async getRoleList() {
      let objdata = this.getAuthObj();
      objdata.sortField = "id";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 100000;

      objdata.apiUrl = this.apiConfig.getSystemRoleAllList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.roleList = data.data.result;
    },
    gotoDetail() {
      let userInfo = this.$store.state.userInfo;
      this.$router.push({ path: "/main/userDetail" });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 1;
      this.init();
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids;

      objdata.apiUrl = this.apiConfig.delSystemUser
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
        this.init();
      }
    },
    handleDbClick:function(row){
      this.$router.push({
        path: "/main/userDetail",
        query: { id: row.id }
      });
    },
  },
  mounted() {
    this.init();
    // this.getRoleList();
  }
};
</script>